import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { FilterHolidays } from "../models/filters/filter-holidays";
import { Observable } from "rxjs";
import { HolidayGroup } from "../models/holiday-group";

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/holidays'; 

  findAllPageableHolidays(filterHolidays: FilterHolidays, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterHolidays);
  }

  findHolidaysById(id: number): Observable<HolidayGroup> {
    return this.http.get<HolidayGroup>(`${this.url}/${id}`);
  }

  createHolidayGroup(holidayGroup: HolidayGroup): Observable<HolidayGroup>{
    return this.http.post<HolidayGroup>(this.url, holidayGroup);
  }

  updateHolidayGroup(holidayGroup: HolidayGroup): Observable<HolidayGroup>{
    return this.http.put<HolidayGroup>(`${this.url}/${holidayGroup.id}`, holidayGroup);
  }
}